import React from 'react';
import { Row } from 'reactstrap';
import { Fade } from 'react-reveal';

const Current = () => {
    return (
        <React.Fragment>
            <Row className='mt-3'>
                <Fade delay={800}>
                    <h2 className='project-text' style={{fontWeight: '400'}}>Currently Working On?</h2>
                </Fade>
                <Fade bottom delay={800}>
                    <h3 className='text'> In my spare time, I build projects that explore <span className='text-primary'>artificial intelligence</span>, <span className='text-primary'>healthcare technology</span>, <span className='text-primary'>modern web development</span>, and <span className='text-primary'>cross-platform mobile applications</span>. </h3>
                </Fade>
            </Row>
        </React.Fragment>
    )
}

export default Current;